module.exports = __webpack_public_path__ + "img/notice_ready.1896115d.png";